import { render, staticRenderFns } from "./PmList.vue?vue&type=template&id=bb66b0dc&"
import script from "./PmList.vue?vue&type=script&lang=js&"
export * from "./PmList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports